module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_5_1.c329dd49.jpeg";